/*
  rima atelier · keeps the personalisation fee in step with personalised abayas

  The fee is a separate product ("Abaya Personalisation", handle
  abaya-personalisation) added next to a personalised abaya by
  rima-personalise.js. Both lines carry the same hidden _pz key. The customer
  can still change either line in the cart, so on every page load and after
  every cart change this reconciles, per key:
    - the fee quantity equals the personalised abaya quantity
    - a fee whose abaya is gone is removed
    - a personalised abaya whose fee is gone gets it back
  If it changed anything on the cart page, the page reloads once so totals are
  right. Loaded on every page from layout/theme.liquid. Guide: docs/personalisation.md
*/
(function () {
  'use strict';

  var FEE_HANDLE = 'abaya-personalisation';
  var busy = false;
  var again = false; // a cart change arrived mid-run: run once more after
  var feeVariantId = null;

  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  function feeVariant() {
    if (feeVariantId) return Promise.resolve(feeVariantId);
    return json('/products/' + FEE_HANDLE + '.js').then(function (p) {
      feeVariantId = p && p.variants && p.variants[0] && p.variants[0].id;
      return feeVariantId;
    });
  }

  // the planner is pure and unit tested: rima-personalise-core.js planFee
  function plan(cart) { return window.RimaPersonaliseCore.planFee(cart, FEE_HANDLE); }

  function apply(steps) {
    return steps.reduce(function (chain, step) {
      return chain.then(function () {
        if (step.change) return json('/cart/change.js', { method: 'POST', body: JSON.stringify(step.change) });
        return feeVariant().then(function (id) {
          if (!id) return null;
          return json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [Object.assign({ id: id }, step.add)] }) });
        });
      });
    }, Promise.resolve());
  }

  function refreshBubble() {
    return fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !s['cart-icon-bubble']) return;
      var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
      var inner = doc.querySelector('.shopify-section') || doc.body;
      bubble.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    json('/cart.js').then(function (cart) {
      var steps = plan(cart);
      if (!steps.length) return false;
      return apply(steps).then(function () { return true; });
    }).then(function (changed) {
      busy = false;
      if (again) { again = false; reconcile(); return; }
      if (!changed) return;
      var onCart = /^\/cart\/?$/.test(location.pathname);
      if (onCart) location.reload();
      else refreshBubble();
    }).catch(function () { busy = false; });
  }

  // expose the pure planner for tests and debugging
  window.RimaPersonaliseCart = { plan: plan, reconcile: reconcile };

  function boot() {
    reconcile();
    // after any cart change: the product form adding a personalised abaya (this
    // is what adds its fee), cart page quantities, removals.
    var CART_UPDATE = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
    if (typeof window.subscribe === 'function') {
      window.subscribe(CART_UPDATE, function (event) {
        setTimeout(reconcile, event && event.source === 'product-form' ? 0 : 250);
      });
    }
  }

  if (!window.RimaPersonaliseCore) return;
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
